import request from '@/utils/request'


// 查询病种科室关联信息列表
export function listDepartLink(query) {
  return request({
    url: '/disease/departLink/list',
    method: 'get',
    params: query
  })
}

// 查询病种科室关联信息分页
export function pageDepartLink(query) {
  return request({
    url: '/disease/departLink/page',
    method: 'get',
    params: query
  })
}

// 查询病种科室关联信息详细
export function getDepartLink(data) {
  return request({
    url: '/disease/departLink/detail',
    method: 'get',
    params: data
  })
}

// 新增病种科室关联信息
export function addDepartLink(data) {
  return request({
    url: '/disease/departLink/add',
    method: 'post',
    data: data
  })
}

// 修改病种科室关联信息
export function updateDepartLink(data) {
  return request({
    url: '/disease/departLink/edit',
    method: 'post',
    data: data
  })
}

// 删除病种科室关联信息
export function delDepartLink(data) {
  return request({
    url: '/disease/departLink/delete',
    method: 'post',
    data: data
  })
}

export function importDiseaseLink(data) {
  return request({
    url: '/disease/departLink/import',
    method: 'post',
    data: data
  })
}


